// Currently not used on web, but keeping for consistency
import { logger } from 'APP/Lib/Datadog'

export const grantedPermissions: string[] = ['granted', 'limited']
export const deniedPermissions: string[] = ['blocked']

// ============= LOCATION ============= //

export function requestLocationService(): Promise<boolean> {
  return new Promise((resolve) => {
    navigator.geolocation.getCurrentPosition(
      () => resolve(true),
      () => resolve(false)
    )
  })
}

export function checkLocationService(): Promise<boolean> {
  return new Promise((resolve) => {
    navigator.permissions.query({ name: 'geolocation' }).then((result) => {
      resolve(result.state === 'granted')
    })
  })
}

export function checkLocationState(): Promise<PermissionState> {
  return new Promise((resolve) => {
    navigator.permissions.query({ name: 'geolocation' }).then((result) => {
      resolve(result.state)
    })
  })
}

export function requestLocation(): Promise<string> {
  return new Promise((resolve) => {
    navigator.geolocation.getCurrentPosition(
      () => resolve('granted'),
      () => resolve('denied')
    )
  })
}

// ============= CAMERA ============= //

export function checkCameraState(): Promise<string> | undefined {
  // Firefox currently doesn't have 'camera' in Permissions query()
  // https://developer.mozilla.org/en-US/docs/Web/API/Permissions_API#browser_compatibility
  const isFirefox = navigator?.userAgent?.toLowerCase().indexOf('firefox') > -1

  if (isFirefox) {
    return new Promise((resolve) => {
      if (navigator.mediaDevices?.getUserMedia) {
        navigator.mediaDevices
          .getUserMedia({
            video: true,
          })
          .then(
            (stream) => {
              const videoTrack = stream && stream.getVideoTracks()[0]
              const permission = videoTrack ? 'authorized' : 'denied'
              if (videoTrack) videoTrack.stop()
              resolve(permission)
            },
            (error) => {
              logger.error('Failed to check camera permission for Firefox:', {}, error)
              resolve('denied')
            }
          )
      }
    })
  } else {
    return new Promise((resolve) => {
      navigator.permissions.query({ name: 'camera' }).then((result) => {
        resolve(result.state)
      })
    })
  }
}

export function requestCameraPermission(): Promise<string> {
  return new Promise((resolve) => {
    navigator.mediaDevices.getUserMedia({ video: true }).then(
      () => resolve('granted'),
      () => resolve('denied')
    )
  })
}

// ============= MICROPHONE ============= //

export function checkMicrophoneState(): Promise<string> | undefined {
  // Firefox currently doesn't have 'camera' in Permissions query()
  // https://developer.mozilla.org/en-US/docs/Web/API/Permissions_API#browser_compatibility
  const isFirefox = navigator?.userAgent?.toLowerCase().indexOf('firefox') > -1

  if (isFirefox) {
    return new Promise((resolve) => {
      if (navigator.mediaDevices?.getUserMedia) {
        navigator.mediaDevices
          .getUserMedia({
            audio: true,
          })
          .then(
            (stream) => {
              const audioTrack = stream && stream.getAudioTracks()[0]
              const permission = audioTrack ? 'authorized' : 'denied'
              if (audioTrack) audioTrack.stop()
              resolve(permission)
            },
            (error) => {
              logger.error('Failed to check microphone permission for Firefox:', {}, error)
              resolve('denied')
            }
          )
      }
    })
  } else {
    return new Promise((resolve) => {
      navigator.permissions.query({ name: 'microphone' }).then((result) => {
        resolve(result.state)
      })
    })
  }
}

export function requestMicrophonePermission(): Promise<string> {
  return new Promise((resolve) => {
    navigator.mediaDevices.getUserMedia({ audio: true }).then(
      () => resolve('granted'),
      () => resolve('denied')
    )
  })
}

// ============= PUSH NOTIFICATIONS ============= //

// Push notifications are currently not supported on web app
export function checkPostNotificationsState(): Promise<undefined> {
  return Promise.resolve(undefined)
}

// Push notifications are currently not supported on web app
export function requestPostNotificationsPermissions(): Promise<undefined> {
  return Promise.resolve(undefined)
}

export function checkCanUseFullScreenIntent(): Promise<boolean> | null {
  return null
}

// ============ BLUETOOTH CONNECT ==================== //
export function checkBluetoothConnectState(): Promise<null> {
  return new Promise((resolve) => {
    resolve(null)
  })
}

export function requestBluetoothConnectPermission(): Promise<string> {
  return new Promise((resolve) => {
    navigator.bluetooth.requestDevice().then(
      () => resolve('granted'),
      () => resolve('denied')
    )
  })
}

// ============= CALENDAR ============= //

// Calendar access is not supported on web, but providing stubs for consistency
export function checkCalendarState(): Promise<null> {
  return Promise.resolve(null)
}

export function requestCalendarPermission(): Promise<undefined> {
  return Promise.resolve(undefined)
}
